import { Box } from '@talos/kyoko';
import styled from 'styled-components';

export const Section = styled(Box)<{ isExpanded: boolean; nonExpandedRows: number }>`
  padding: ${({ theme }) => theme.spacing4}px ${({ theme }) => theme.spacing8}px;
  // TODO - this is a hack to make the height transition works
  max-height: ${({ isExpanded, nonExpandedRows }) =>
    isExpanded ? 400 : nonExpandedRows * 24 + 8}px; // each row is 24px, and there's 4*2 vertical padding
  overflow: hidden;
  transition:
    max-height 200ms linear,
    margin 200ms linear;
  background: ${({ theme }) => theme.backgroundCard};
  border-radius: ${({ theme }) => theme.borderRadiusDefault}px;
  border: ${({ theme }) => `1px solid ${theme.borderColorPopover}`};
`;

export const Ratio = styled.div<{ value: number }>`
  margin-right: 4px;
  color: ${({ theme, value }) => (value > 0 ? theme.colors.green.lighten : theme.colors.red.lighten)};
`;
